import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from '@env'

if (environment.production) {
  enableProdMode()
}

window['loadGoogleAnalytics'](environment.GOOGLE_ANALYTICS_TRACKING_CODE)

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
